export default __webpack_public_path__ + "static/media/jenn.ba6d4682.jpg";